import { UserRoleInfoRow, UserRoleMaintenancePageState } from ".";
import { INIT_ERROR_RESULT_DATA } from "../../util";
import {
  InDefCommonFlagType,
  RoleCvrgType,
} from "../../util/general-code/enums/general-codes";
import { Option } from "../../util/option";

export const DISPLAY_COLUMN = [
  { label: "User ID", value: "userId" },
  { label: "User Name", value: "userName" },
  { label: "Mail Address", value: "mlAdrs" },
  { label: "User Delete Flag", value: "delFlg" },
  { label: "Role Code", value: "roleCd" },
  { label: "Coverage Code", value: "cvrgCd" },
  { label: "Primary Flag", value: "primFlg" },
];

export const CVRG_CD_JEDI_DROPDOWN_ITEM: Option = {
  label: RoleCvrgType.JEDI,
  value: RoleCvrgType.JEDI,
};

export const INITIAL_SPREADSHEET_ROW: UserRoleInfoRow = {
  ...INIT_ERROR_RESULT_DATA,
  addFlg: InDefCommonFlagType.YES,
  delCheckBox: false,
  userRoleInfo: {
    userId: "",
    emplyNum: "",
    userName: "",
    mlAdrs: "",
    delFlg: "",
    roleCd: "",
    roleName: "",
    cvrgCd: "",
    primFlg: "",
    updateDateTime: "",
  },
};

export const UserRoleMaintenancePageInitialState: UserRoleMaintenancePageState =
  {
    searchResult: {
      getUserRolesResp: undefined,
    },
    spreadsheetSelectedRowIndex: undefined,
    displayColumn: DISPLAY_COLUMN,
  };
